<template>
  <adivare-results-loading
      :show-spinner="false"
      :fader="false"
  >
    <div :class="['row', { loading: waitingForHouses }]">
      <template v-if="rentals !== undefined && rentals !== null && rentals.length !== 0">
        <adivare-list-item-wrapper
            v-for="(rental, index) in rentals"
            :index="index"
            :key="rental.id"
            :rental="rental"
        ></adivare-list-item-wrapper>
      </template>
      <div
          v-else-if="false === waitingForHouses"
          class="col-md-12"
      >
        <div class="alert alert-info xs-mt-10">
          {{ $t('messages_nl.catalog.cta0', {'location': title}) }}
          <template v-if="user === ''">
            <a
                style="font-weight: bold;"
                :href="path"
            >
              {{ $t('messages_nl.catalog.cta1-1') }}
            </a>
            {{ ' '+$t('messages_nl.catalog.cta1-2') }}
          </template>
          <a
              v-else
              style="font-weight: bold;"
              :href="path"
          >
            {{ $t('messages_nl.catalog.cta2') }}
          </a>
          {{ $t('messages_nl.catalog.cta3', {'location': title}) }}
        </div>
      </div>
    </div>
  </adivare-results-loading>
</template>

<script>
import sharedJS from '../../../../../common/vue/components-js/rentals-list.js';
import AdivareListItemWrapper from './list-item-wrapper';
import rentalCardLoading from "./list-item-loading";

export default {
  components: {
    rentalCardLoading,
    AdivareListItemWrapper,
  },
  extends: sharedJS,
}
</script>
